import * as React from 'react';

import { Container } from '@rbilabs/components-library/build/components/layout';

import { designTokens } from 'styles/constants/design-tokens';

import { StoreActionsButton, StoreActionsCard, StoreActionsError } from './components';
import { IStoreActionsViewProps } from './types';

export const StoreActionsView: React.FC<IStoreActionsViewProps> = ({ options, message }) => {
  return (
    <Container background={designTokens['background-default']}>
      <StoreActionsCard>
        {options.map(({ id, disabled, icon, text, onClick, loading }) => {
          return (
            <StoreActionsButton
              key={id}
              disabled={!!disabled}
              icon={icon}
              id={id}
              text={text}
              onClick={onClick}
              loading={loading}
            />
          );
        })}
      </StoreActionsCard>

      {message && <StoreActionsError message={message} />}
    </Container>
  );
};
